import { useLoadingStore } from '@/stores/loading';

export function useLoading() {
  const loadingStore = useLoadingStore();

  const openLoading = (text = 'Cargando...') => {
    loadingStore.setLoading(true, text);
  };

  const closeLoading = () => {
    loadingStore.closeLoading();
  };

  return { openLoading, closeLoading };
}
